export const SettingKey = {
    THREAT_CONTACT: 'threat_contact',
};
